import { render, staticRenderFns } from "./merchant copy.vue?vue&type=template&id=443725ea&scoped=true&"
import script from "./merchant copy.vue?vue&type=script&lang=js&"
export * from "./merchant copy.vue?vue&type=script&lang=js&"
import style0 from "./merchant copy.vue?vue&type=style&index=0&id=443725ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443725ea",
  null
  
)

export default component.exports